/*
 * @Author: LiZhiWei
 * @Date: 2026-01-29 14:26:20
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-13 14:16:07
 * @Description: 
 */
/**
 * @Description: 导航相关配置数据
 */

export const navLinks = [
  { title: '首页', link: '/' },
  { title: '产品中心', type: 'product' },
  { title: '解决方案', type: 'solution' },
  { title: '客户案例', link: '/case-studies' },
  { title: '荣誉资质', link: '/honor-qualification' },
  { title: '关于绘家', link: '/about' },
]

export const productItems = [
  {
    title: '绘管家',
    desc: '让物业管理更简单',
    icon: 'i-custom-cp-hgj',
    link: 'https://www.huiguanjia.cn/',
  },
  {
    title: '绘服务',
    desc: '足不出户尽享物业服务',
    icon: 'i-custom-cp-hfw',
    link: 'https://www.huifuwu.cn/',
  },
]
